import { render, staticRenderFns } from "./sms_reply_record.vue?vue&type=template&id=1c19604f&scoped=true"
import script from "./sms_reply_record.vue?vue&type=script&lang=js"
export * from "./sms_reply_record.vue?vue&type=script&lang=js"
import style0 from "./sms_reply_record.vue?vue&type=style&index=0&id=1c19604f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19604f",
  null
  
)

export default component.exports